import AdministratorsApi from '../../core/api/AdministratorsApi'

export const ADMINISTRATOR_LOGGED_IN = 'ADMINISTRATOR_LOGGED_IN'
export const ADMINISTRATOR_LOGGED_OUT = 'ADMINISTRATOR_LOGGED_OUT'
export const ADMINISTRATOR_LOGGING_IN = 'ADMINISTRATOR_LOGGING_IN'
export const ADMINISTRATOR_LOGIN_FAILED = 'ADMINISTRATOR_LOGIN_FAILED'
export const ADMINISTRATOR_SET_EMAIL_ADDRESS = 'ADMINISTRATOR_SET_EMAIL_ADDRESS'
export const ADMINISTRATOR_SET_PASSWORD = 'ADMINISTRATOR_SET_PASSWORD'

export const administratorLoggingIn = () => ({
  type: ADMINISTRATOR_LOGGING_IN
})

export const administratorLogOut = () => ({
  type: ADMINISTRATOR_LOGGED_OUT
})

export const setEmailAddress = (emailAddress) => ({
  type: ADMINISTRATOR_SET_EMAIL_ADDRESS,
  emailAddress: emailAddress
})

export const setPassword = (password) => ({
  type: ADMINISTRATOR_SET_PASSWORD,
  password: password
})

export function login (emailAddress, password) {
  const api = new AdministratorsApi()
  const request = api.login(emailAddress, password)

  return (dispatch) => {
    dispatch(administratorLoggingIn())
    request.then(function (payload) {
      if (typeof Response !== 'undefined' && payload instanceof Response) {
        dispatch({
          type: ADMINISTRATOR_LOGIN_FAILED
        })
        return
      }

      dispatch({
        type: ADMINISTRATOR_LOGGED_IN,
        payload: payload
      })
    }).catch(function () {
      dispatch({
        type: ADMINISTRATOR_LOGIN_FAILED
      })
    })
  }
}
